import { Clock } from "lucide-react";

import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { getCreativeFatigueBarColor } from "@/lib/chart";
interface FatigueItem {
  label: string;
  level: number;
}

export function CreativeFatigueTracker({ items, blurred }: { items: FatigueItem[]; blurred?: boolean }) {
  return (
    <Card className={cn("flex flex-col flex-1 min-w-0", blurred && "blur-[1px] select-none pointer-events-none")}>
      <CardHeader className="flex flex-row items-center gap-2">
        <div className="rounded-md bg-destructive/10 p-2">
          <Clock className="size-5 text-destructive" strokeWidth={2.5} />
        </div>
        <CardTitle className="text-base font-semibold">Creative Fatigue Tracker</CardTitle>
      </CardHeader>
      <CardContent className="pt-0 space-y-4">
        {items.map((item) => (
          <div key={item.label} className="flex items-center gap-20">
            <p className="w-48 shrink-0 text-sm text-foreground">{item.label}</p>
            <div className="h-2 flex-1 overflow-hidden rounded-full bg-muted">
              <div className={cn("h-full rounded-full transition-all", getCreativeFatigueBarColor(item.level))} style={{ width: `${item.level}%` }} />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
